export default "__VITE_ASSET__CBBZjkvR__"